<template>
  <div>
    <!-- top search bar -->
    <div class="pa-5 d-flex">
      <div class="form-input-group flex-grow-1 mr-5">
        <div class="prepend-icon" style="top: 45%;">
          <v-icon>search</v-icon>
        </div>
        <input
          type="text"
          class="pl-42px"
          placeholder="搜尋"
          v-model="filter.keyword"
        />
      </div>
      <SimpleSelectWithSearchInput
        class="mr-5"
        buttonPlaceholder="篩選年份"
        :isOnlyShowButtonPlaceholder="true"
        buttonWidth="140px"
        modalWidth="140px"
        :options="yearOptions"
        :selectedValue.sync="filter.year"
      ></SimpleSelectWithSearchInput>
      <SimpleSelectWithSearchInput
        class="mr-5"
        buttonPlaceholder="篩選Tab"
        :isOnlyShowButtonPlaceholder="true"
        buttonWidth="140px"
        modalWidth="200px"
        :options="newsTypeOptions"
        :selectedValue.sync="filter.tab"
      ></SimpleSelectWithSearchInput>
      <TableControlShowState v-model="filter.status"></TableControlShowState>
      <button class="btn btn-primary w-88px" @click="getNewsList">搜尋</button>
    </div>

    <!-- filter condition -->
    <div class="px-5 mb-5 d-flex" v-if="filter.year != '' || filter.tab != ''">
      <div
        class="h5 ink-02-medium--text h-32px w-70px d-flex align-center flex-shrink-0"
      >
        篩選條件：
      </div>
      <div class="flex-wrap">
        <!-- filter year -->
        <v-chip
          v-if="filter.year != ''"
          close
          class="ml-5 mb-2"
          @click:close="filter.year = ''"
        >
          {{ filter.year }}
        </v-chip>

        <!-- filter tab -->
        <v-chip
          v-if="filter.tab != ''"
          close
          class="ml-5 mb-2"
          @click:close="filter.tab = ''"
        >
          {{ tabName }}
        </v-chip>

        <!-- filter subcategory -->
        <!-- <v-chip
          close
          class="ml-5 mb-2"
          v-for="(subcat, indexOfSubcat) in selectedSubcategories"
          :key="subcat"
          @click:close="selectedSubcategories.splice(indexOfSubcat, 1)"
        >
          {{ subcat }}
        </v-chip> -->
      </div>
    </div>

    <!-- table -->
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <div v-if="lengthOfisCheckedList > 0"
             class="form-item d-flex align-center px-5 h-60px batch">
          <h5 class="col-checkbox">
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </h5>
          <h5 class="mr-22px">{{ lengthOfisCheckedList }} 項已選取</h5>
          <div>
            <button class="btn btn-danger mr-10px" @click="multiDelete">
              <v-icon color="white" class="mr-2">delete</v-icon>
              <span>刪除</span>
            </button>
          </div>
          <div>
            <button class="btn mr-10px" @click="multiChangeStatus(true)">設為顯示</button>
          </div>
          <div>
            <button class="btn" @click="multiChangeStatus(false)">設為隱藏</button>
          </div>
        </div>
        <tr>
          <th>
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </th>
          <th class="text-left">Date</th>
          <th class="text-left">News Title</th>
          <th class="text-left">Tab</th>
          <th class="text-left">顯示/隱藏</th>
          <th class="text-left">置頂</th>
          <th class="text-left">編輯</th>
          <th class="text-left">刪除</th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in newsList"
          :key="item.id"
        >
          <td>
            <v-checkbox v-model="item.isChecked"></v-checkbox>
          </td>
          <td class="w-140px">{{ item.published_at }}</td>
          <td>{{ item.title }}</td>
          <td>{{ item.tab }}</td>
          <td>
            <FormSwitch v-model="item.status"
                        @changeStatus="toggleStatus(item.id)"></FormSwitch>
          </td>
          <td class="col-icon">
            <button class="btn square" @click="toggleIsTop(item.id)">
              <v-icon v-if="item.is_top" color="warning-500">star</v-icon>
              <v-icon v-else>star_outline</v-icon>
            </button>
          </td>
          <td>
            <button class="btn square" @click="toNewsEdit(item.id)">
              <v-icon>edit</v-icon>
            </button>
          </td>
          <td>
            <deleteDialog @confirm-delete="deleteItem(item.id)"></deleteDialog>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- table footer -->
    <Pagination @handleNextPreEvent="getNewsList" model="news"></Pagination>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import TableControlShowState from '@/components/TableControlShowState.vue';
import FormSwitch from '@/components/FormSwitch.vue';
import Pagination from '@/components/Pagination.vue';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';

export default {
  components: {
    SimpleSelectWithSearchInput,
    TableControlShowState,
    FormSwitch,
    Pagination,
    deleteDialog,
  },
  data: () => ({
    // filter
    checkAllStatus: false, // left top checkbox status
    // selectedItems
    selectedItems: [],
  }),
  computed: {
    ...mapState('news', ['newsList', 'filter', 'newsTypeOptions']),
    lengthOfisCheckedList() {
      return this.newsList.filter((item) => item.isChecked)
        .length;
    },
    indeterminate() {
      if (
        this.lengthOfisCheckedList === 0 ||
        this.lengthOfisCheckedList === this.newsList.length
      ) {
        return false;
      }
      return true;
    },
    isCheckedListIds() {
      return this.newsList.filter((item) => item.isChecked).map((item) => item.id);
    },
    tabName() {
      const tab = this.newsTypeOptions.find((item) => item.value === this.filter.tab);
      return tab.text || '';
    },
    typeName() {
      const type = this.awardTypeOptions.find((item) => item.value === this.filter.type);
      return type.text || '';
    },
    yearOptions() {
      const startYear = 1991;
      const range = new Date().getFullYear() - startYear + 1;
      return [...Array(range).keys()].map((i) => ({
        value: (i + startYear).toString(),
        text: (i + startYear).toString(),
      }));
    },
  },
  watch: {
    lengthOfisCheckedList(newValue) {
      if (newValue < this.newsList.length) {
        this.checkAllStatus = false;
      }
      if (newValue === this.newsList.length) {
        this.checkAllStatus = true;
      }
    },
  },
  methods: {
    ...mapActions('news', {
      getNewsList: 'find',
      destroyNews: 'destroy',
      clear: 'clear',
      changeIsTop: 'changeIsTop',
      changeStatus: 'changeStatus',
    }),
    toNewsEdit(id) {
      this.$router.push({
        name: 'NewsEdit',
        params: { id },
      });
    },
    changeAllCheckbox() {
      if (this.checkAllStatus) {
        this.newsList.forEach(
          (item) => (item.isChecked = true),
        );
      } else {
        this.newsList.forEach(
          (item) => (item.isChecked = false),
        );
      }
    },
    async deleteItem(id) {
      this.clear();
      await this.destroyNews(id).then(() => {
        this.getNewsList();
      });
    },
    async multiDelete() {
      await this.isCheckedListIds.forEach((id) => {
        this.destroyNews(id).then(() => {});
      });
      this.getNewsList();
    },
    async multiChangeStatus(status) {
      await this.isCheckedListIds.forEach((id) => {
        this.changeStatus({
          id, status,
        }).then(() => {});
      });
      this.getNewsList();
    },
    toggleStatus(id) {
      this.changeStatus({ id }).then(() => {
        this.getNewsList();
      });
    },
    toggleIsTop(id) {
      this.changeIsTop(id).then(() => {
        this.getNewsList();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-date {
    width: 75px;
    margin-right: 40px;
  }
  .col-news-title {
    width: 390px;
    margin-right: 50px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .col-tab {
    width: 130px;
    margin-right: 10px;
  }
  .col-show {
    margin: 0 20px;
  }
}
</style>
